import './App.css';
import './common.scss';
import 'font-awesome/css/font-awesome.min.css';
import getRoutes from '../src/router/routerLinks';
import React from 'react';
import Header from '../src/components/Header/header';
import Sidebar from '../src/components/Sidebar/sidebar';
import { Routes, Route, BrowserRouter, useLocation, Navigate, useNavigate, matchPath } from 'react-router-dom';
import { ToastContainer } from "react-toastify";
import "antd/dist/reset.css";
import Chatbot from '../src/pages/ChatBot/ChatBot';
import ChatBoatGuest from '../src/pages/ChatBotGuest/ChatBoatGuest';

import "react-toastify/dist/ReactToastify.css";
import globalRouter from "./utils/globalRouter";

import PvtRoute from "../src/router/pvtRoutes";
import { GoogleOAuthProvider } from "@react-oauth/google";
import AppSubheader from "./components/AppSubheader/AppSubheader";
import NotFoundPage from "./pages/NotFound/NotFoundPage";
import { GOOGLE_WEB_CLIENT_ID } from "./config/googleOAuth";
import    CoinPop from "../src/pages/canvasConfict"
const Layout = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const routes = getRoutes() || [];

  // Allow non-component code (like RTK Query baseQuery) to redirect.
  React.useEffect(() => {
    globalRouter.setNavigator(navigate);
  }, [navigate]);

  // Define public routes where Header & Sidebar should NOT appear
  const publicRoutes = ['/', '/login', '/register', '/verify-otp', "/home"];

  const isPublicRoute = publicRoutes.includes(location.pathname);
  const isKnownRoute = routes.some((r) => {
    if (!r?.path) return false;
    return !!matchPath({ path: r.path, end: true }, location.pathname);
  });
  const isNotFoundRoute = !isKnownRoute;

  return (
    <div className="app">
      {/* Hide sidebar & header on public routes */}
      {!isPublicRoute && !isNotFoundRoute && <Sidebar />}
      {!isPublicRoute && !isNotFoundRoute && <Header />}
      {!isPublicRoute && !isNotFoundRoute && <AppSubheader />}
      {!isPublicRoute && !isNotFoundRoute && <CoinPop/>} 

      <div className={isPublicRoute || isNotFoundRoute ? "" : "home-section1 app-route-shell"}>
        <Routes>
          {routes.map((val, i) => (
            <Route
              key={i}
              path={val.path}
              element={
                publicRoutes.includes(val.path) ? (
                  (localStorage.getItem("token") || sessionStorage.getItem("token")) &&
                    (val.path === "/" || val.path === "/login" || val.path === "/register") ? (
                    <Navigate to="/dashboard" replace />
                  ) : (
                    <val.component />
                  )
                ) : (
                  <PvtRoute path={val.path} children={val} />
                )
              }
            />
          ))}
          <Route path="*" element={<NotFoundPage />} />
        </Routes>

        {/* {!hideLoginOverlays && ( */}
          <>
            <ToastContainer
            className="toast-setting"
            
              position="top-right"
              autoClose={1300}
              hideProgressBar={false}
              newestOnTop={true}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
              theme="colored"
            />
          </>
        {/* )} */}

        {!isPublicRoute && !isNotFoundRoute && <Chatbot />}
        {location.pathname === "/" && <ChatBoatGuest />}
      </div>
    </div>
  );
};

const App = () => {
  return (
    <GoogleOAuthProvider clientId={GOOGLE_WEB_CLIENT_ID} locale="en">
      <BrowserRouter>
        <Layout />
      </BrowserRouter>
    </GoogleOAuthProvider>
  );
};

export default App;
